export default "<app-chart \n  chartType=\"radar\" \n  [chartDataSet]=\"radarChartData\" \n  [chartLabels]=\"radarChartLabels\"\n></app-chart>\n";